module.exports = __webpack_public_path__ + "static/media/computer.b821365d.png";


//////////////////
// WEBPACK FOOTER
// ./src/Static/image/computer.png
// module id = 399
// module chunks = 0